import { EventVm, MatchDetailVm, UpdateEventCommand } from '../../../../utils/api';
import Timeout from './Timeout';

interface OwnProps {
    event: UpdateEventCommand;
    match: MatchDetailVm | undefined;
    updateEvent: (event: UpdateEventCommand) => void;
    clearEvent: () => void;
    deleteEvent: (event: EventVm) => void;
}

export type Props = OwnProps;

export default Timeout;
